import { render } from "./NotificationsMain.vue?vue&type=template&id=58237e5d"
import script from "./NotificationsMain.vue?vue&type=script&lang=js"
export * from "./NotificationsMain.vue?vue&type=script&lang=js"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__